import { all, call, put, takeEvery } from 'redux-saga/effects';
import {
  CREATE_APPCONFIG,
  GET_APPCONFIG_LIST,
  UPDATE_APPCONFIG,
  DELETE_APPCONFIG,
  GET_PATIENT_PLAN_LIST,
  GET_DISCHARGE_FORM,
  GET_PATIENT_PLAN_DETAILS,
} from '../storeTypes';
import {
  CreateAppconfigApi,
  DeleteAppconfigApi,
  GetAppconfigApi,
  GetPatientDischargeApi,
  GetPatientPlanApi,
  GetPatientPlanDetailsApi,
  UpdateAppconfigApi,
} from '../../utils/api';
import {
  ActionAppConfigListSuccess,
  ActionGetPatientDischargeFormSuccess,
  ActionGetPatientPlanSuccess,
  ActionGetPatientPlanDetailsSuccess,
} from '../Actions/AppConfigAction';
import { handleApiResponse } from '../../utils/functions';

const File = 'appConfigSaga';
function* GetAppConfigSaga(action) {
  try {
    const response = yield call(GetAppconfigApi, action.payload);
    if (response?.status == 200) {
      yield put(ActionAppConfigListSuccess(response?.data?.data));
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callBack, true);
  }
}
function* GetPatientPlanSaga(action) {
  try {
    const response = yield call(GetPatientPlanApi, action.payload);
    if (response?.status == 200) {
      yield put(ActionGetPatientPlanSuccess(response?.data?.data?.[0]));
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callBack, true);
  }
}

function* GetPatientPlanDetailsSaga(action) {
  try {
    const response = yield call(GetPatientPlanDetailsApi, action.payload);
    if (response?.status == 200) {
      yield put(ActionGetPatientPlanDetailsSuccess(response?.data?.data));
      if (action?.callBack) {
        action?.callBack(response?.data);
      }
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callBack, true);
  }
}

function* GetPatientDischargeSaga(action) {
  try {
    const response = yield call(GetPatientDischargeApi, action.payload);
    if (response?.status == 200) {
      yield put(ActionGetPatientDischargeFormSuccess(response?.data?.data));
      // Call the callback on success
      if (action?.callBack) {
        action?.callBack(response?.data);
      }
    } else {
      // Handle non-200 responses
      if (action?.callBack) {
        action?.callBack(response?.data);
      }
    }
  } catch (error) {
    handleApiResponse(error?.response?.status, error?.response?.data, action?.callBack, true);
  }
}
function* CreateAppConfigSaga(action) {
  try {
    const response = yield call(CreateAppconfigApi, action.payload);
    if (response?.status === 200) {
      action?.callBack(response?.data);
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callBack, true);
  }
}
function* UpdateAppConfigSaga(action) {
  try {
    const response = yield call(UpdateAppconfigApi, action.payload);
    if (response?.status === 200) {
      handleApiResponse(response.status, response?.data, action?.callBack, true);
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callBack, true);
  }
}
function* DeleteAppConfigSaga(action) {
  try {
    const response = yield call(DeleteAppconfigApi, action.payload);
    if (response?.status === 200) {
      handleApiResponse(response.status, response?.data, action?.callBack, true);
    }
  } catch (error) {
    handleApiResponse(error?.response.status, error?.response?.data, action?.callBack, true);
  }
}

export function* appConfigSaga() {
  yield all([
    takeEvery(GET_APPCONFIG_LIST, GetAppConfigSaga),
    takeEvery(CREATE_APPCONFIG, CreateAppConfigSaga),
    takeEvery(UPDATE_APPCONFIG, UpdateAppConfigSaga),
    takeEvery(GET_PATIENT_PLAN_LIST, GetPatientPlanSaga),
    takeEvery(GET_PATIENT_PLAN_DETAILS, GetPatientPlanDetailsSaga),
    takeEvery(GET_DISCHARGE_FORM, GetPatientDischargeSaga),
    takeEvery(DELETE_APPCONFIG, DeleteAppConfigSaga),
  ]);
}
